import { render, staticRenderFns } from "./productDetailModal.vue?vue&type=template&id=fdeb5fc4&scoped=true"
import script from "./productDetailModal.vue?vue&type=script&lang=js"
export * from "./productDetailModal.vue?vue&type=script&lang=js"
import style0 from "./productDetailModal.vue?vue&type=style&index=0&id=fdeb5fc4&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "fdeb5fc4",
  null
  
)

export default component.exports